import LogoDesktopSvg from '@/assets/LogoDesktopSvg.svg';
import LogoMobileSvg from '@/assets/LogoMobileSvg.svg';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useLayoutContext } from '@/utils/providers/layoutContext/useUserContext.tsx';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import React, { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

import { Providers } from '../Providers.tsx';
import LanguageSwitcher from './LanguageSwitcher';
import NarratorToggle from './NarratorToggle';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const isMobile = useMobileMediaQuery();
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');
  // A callback ref, so pages always get the current slot when the header switches between layouts
  const { setHeaderSlot } = useLayoutContext();

  return (
    <div className={`app-wrapper m-auto ${isAdminPage ? 'max-w-[1700px]' : 'max-w-7xl'}`}>
      {isMobile ? (
        <div className="flex items-center justify-between">
          <img alt="logo-mobile" src={generateNonCachableImageSrc(LogoMobileSvg)} />
          <div className="flex items-stretch gap-2">
            <div className="flex items-center" ref={setHeaderSlot} />
            <LanguageSwitcher />
            {!isAdminPage && <NarratorToggle />}
          </div>
        </div>
      ) : (
        <div className="py-[25px] flex items-center justify-between">
          <img alt="logo-desktop" src={generateNonCachableImageSrc(LogoDesktopSvg)} />
          {/* the logo stays on a printout, e.g. the admin dashboard as PDF, the controls do not */}
          <div className="flex items-stretch gap-3 print:hidden">
            <div className="flex items-center" ref={setHeaderSlot} />
            <LanguageSwitcher />
            {!isAdminPage && <NarratorToggle />}
          </div>
        </div>
      )}
      <Providers>
        <main className="flex w-full justify-between">{children}</main>
      </Providers>
    </div>
  );
};

export default Layout;
